module.exports = __webpack_public_path__ + "static/team-80dc5ec2731996da89bffdd82585b453.jpeg";